<template>
    <div class="main-container">
        <!-- Выводим управляющие кнопки -->
        <dir class="row no-wrap justify-end q-pr-md q-pt-lg">
            <q-btn 
                color='positive' 
                label="Добавить нового"
                icon="add"
                @click='addNewClient'
            />
        </dir>
        <!-- выводим основную таблицу с клиентами -->
        <div class="q-pl-md q-pr-md q-pt-md">
            <!-- Заголовок таблицы -->
            <div class="row no-wrap text-center table-title items-center">
                <div class='col-sm-2 col-xs-2 col-md-1 col-lg-1 col-xl-1 border-right ellipsis'>
                    <q-icon name='menu'/>
                   <!-- под управляющие кнопки -->
                </div>
                <div class="col-xs-5 col-sm-3 col-md-3 col-lg-3 col-xl-3 q-pa-xs border-right ellipsis">Наименование</div>
                <div class="gt-xs col-2 q-pa-xs border-right ellipsis">Контакт</div>
                <div class="gt-md col-1 q-pa-xs border-right ellipsis">Телефон</div>
                <div class="gt-md col-1 q-pa-xs border-right ellipsis-2-lines">Отсрочка/Лимит</div>
                <div class="col-3 gt-xs q-pa-xs border-right ellipsis">Комментарии</div>
                <div class="col-lg-1 col-xl-1 col-md-3 q-pa-xs ellipsis">Менеджер</div>
            </div>
            <!-- выводим основные данные -->
            <div 
                v-for='item in contragents' 
                :key='item.id' 
                class='row no-wrap items-center text-truncate text-no-wrap contragent-line'
                v-bind:class="{ blocked_line : item.active==0 }"
            >

                <div class="col-sm-2 col-xs-2 col-md-1 col-lg-1 col-xl-1 ellipsis border-right text-center">

                    <q-btn-dropdown  icon="menu" flat dense size='sm' color='primary' v-if='item.lock_at==null'>
                        <!-- dropdown content -->
                        <q-list link>
                            <q-list-header>
                                Выбор действия
                            </q-list-header>
                            <q-item-separator />

                            <q-item v-close-overlay @click.native='toggleBlockContragent(item)' size='sm'>
                                <q-item-side icon="lock" inverted color="primary"  v-if='item.active==1'/>
                                <q-item-side icon="lock_open" inverted color="primary"  v-if='item.active==0'/>
                                <q-item-main>
                                    <q-item-tile label v-if='item.active==1'>Заблокировать контрагента</q-item-tile>
                                    <q-item-tile sublabel v-if='item.active==1'>Запретить запуски в работу</q-item-tile>
                                    
                                    <q-item-tile label v-if='item.active==0'>Разблокировать контрагента</q-item-tile>
                                    <q-item-tile sublabel v-if='item.active==0'>Разрешить запуски в работу</q-item-tile>

                                </q-item-main>
                            </q-item>

                            <q-item v-close-overlay @click.native='editContragent(item)' size='sm'>
                                <q-item-side icon="edit" inverted color="positive" />
                                <q-item-main>
                                    <q-item-tile label >редактировать запись</q-item-tile>
                                </q-item-main>
                            </q-item>

                            <q-item v-close-overlay @click.native='deleteContragent(item)' size='sm'>
                                <q-item-side icon="delete" inverted color="negative" />
                                <q-item-main>
                                    <q-item-tile label >удалить запись</q-item-tile>
                                </q-item-main>
                            </q-item>

                        </q-list>
                    </q-btn-dropdown>                    
                    <q-icon name='lock' v-if='item.lock_at!=null' color='red-10' v-on:dblclick.native="forceUnlock(item)">
                            <q-tooltip :delay="500">
                                {{lockInfo(item)}}
                            </q-tooltip> 
                    </q-icon>
                </div>
                <div class="col-xs-5 col-sm-3 col-md-3 col-lg-3 col-xl-3 q-pa-xs ellipsis border-right text-weight-medium">{{item.name}}</div>
                <div class="gt-xs col-2 q-pa-xs ellipsis border-right">{{item.contact}}</div>
                <div class="gt-md col-1 q-pa-xs ellipsis border-right">{{item.phone}}</div>
                <div class="gt-md col-1 q-pa-xs ellipsis text-center border-right">{{item.postpay}}/{{item.debitLimit}}</div>
                <div class="col-3 gt-xs q-pa-xs ellipsis border-right">{{item.comment}}</div>
                <div class="col-lg-1 col-xl-1 col-md-3 q-pa-xs ellipsis text-center">{{getManager(item.managerId)}}</div>

            </div>
        </div>
        <!-- <edit-dialog/> -->
    </div>
</template>

<script>
/* eslint-disable */
export default {

    name : 'contragents',

    components : {
        // editDialog : ()=>import('./contragentEditDialog.vue'),
    },
    data() {
        return {
            dropDownOpen : false,
        }
    },

    created() {
        // для работы нужен список контрагентов. Проверяем есть ли он
        let list = this.$store.getters.allContragents;
        if (list.length ==0 ) { //Возможно список контрагентов не загружен - загружаем его
            this.$store.dispatch('retrieveContragents')
            .then()
            .catch((error)=>{
                console.log(error);
                this.$admns.showNotify('Ошибка загрузки списка контрагентов','error','Сообщение системы')
            });
        }

        list = this.$store.getters.allPrices;
        if (list.length ==0 ) { //Возможно список прайс-листов не загружен - загружаем его
                this.$store.dispatch('retrievePrices')
                .then()
                .catch((error)=>{
                    console.log(error);
                    this.$admns.showNotify('Ошибка загрузки прайсов','error','Сообщение системы')
                });
        }   
        list = this.$store.getters.allUsers;
        if (list.length ==0 ) { //Возможно список пользователей не загружен - загружаем его
                this.$store.dispatch('retrieveUsers')
                .then()
                .catch((error)=>{
                    console.log(error);
                    this.$admns.showNotify('Ошибка загрузки списка пользователей','error','Сообщение системы')
                });
        }   
        

    },
    
    computed :{

        contragents() {
            return this.$store.getters.allContragents;
        }

    },

    methods : {

        forceUnlock(item) { //принудительная разблокировка заказа
            //сначала спрашиваем
            this.$q.dialog({
                    title: 'Принудительная разблокировка',
                    message: 'Подтвердите принудительную разблокировку контрагента. Надеемся это Вам действительно необходимо.',
                    color: 'primary',
                    ok: 'Разблокировать', 
                    cancel: 'Отмена',
            })
            .then(()=> {

                this.$store.dispatch('unlockContragent', item.id)
                .then(() => {
                    this.$admns.showNotify('Контрагент разблокирован.','success','Сообщение системы')
                })
                .catch((error) => {
                    this.$admns.showNotify('Ошибка при разблокировке','error','Сообщение системы')
                });

            })
            .catch();
        },


        lockInfo(item) {
            let user = this.$store.getters.getUserById(item.lock_by);
            let blockName = user != null ? 'Заблокировано: '+ user.name + " " + user.surname : 'Заблокировано: '+ 'Неизвестно'
            let result = '';
            let d = new Date(item.lock_at);
            result += blockName +' -- ' + d.toLocaleTimeString();
            return result;
        },

        getManager(id) {
            var result = this.$store.getters.getUserById(id);
            if (result == undefined) return '';
            else return result.name;
        },

        saveContragent(item) {

            this.$store.dispatch('saveContragent', item)
            .then(()=>{
            })
            .catch((error)=>{
                console.log(error);
                this.$admns.showNotify('Ошибка сохранения данных','error','Сообщение системы');
            });

        },

        toggleBlockContragent(item) {

            if (item.active==1) item.active = 0; //устанавливаем флаг блокировки
            else item.active = 1;

            this.saveContragent(item);

        },

        editContragent(item) {
            this.$store.dispatch('lockContragent', item.id)
            .then(()=>eventBus.$emit('openContragentEditDialog', item.id))
            .catch(error=>{
                this.$admns.showNotify('Не удалось заблокировать запись','error', 'Сообщение системы');
                console.log(error);
            })
        },

        addNewClient(){
            eventBus.$emit('openContragentEditDialog', -1);
        },

        deleteContragent(item) {
            this.$q.dialog({
                title: 'Внимание!',
                message: 'Подтвердите удаление контрагента "'+item.name+'"',
                ok : 'Удалить',
                cancel : 'Отмена'
            })
            .then(()=>{
               this.$store.dispatch('deleteContragent', item) 
               .then(()=>{
                   this.$admns.showNotify('Контрагент удален','success','Сообщение системы')
               })
               .catch(error=>{
                   console.log(error);
                   this.$admns.showNotify('Ошибка при удалении','error','Сообщение системы')
               });
            })
            .catch(()=>{})
        }
    }

}
</script>

<style scoped>
    .main-container {
        width : 100%;
        margin:auto;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
      }
    .text-center {
        text-align: center;
    }
    .table-title {
        background: #027be3;
        color:white;
        min-height: 35px;
    }
    .contragent-line {
        min-height: 35px;
        padding:5px;
        border : 1px solid rgb(189, 189, 189);
        border-top : 0px;
        font-size : 14px;
    }
    .contragent-line:hover{
            background: rgb(166, 252, 166);
    }

    .blocked_line {
        background: rgb(255, 209, 209);
    }

    .border-right {
        border-right: 1px solid white;
    }
</style>
